import { IPageSectionEntry } from '../../../shared/api/contentful/types';
import { mergeNeighbouringQuickLinkSections } from './mergeNeighbouringQuickLinkSections';

export function enrichSections(sections: IPageSectionEntry[]) {
	return mergeNeighbouringQuickLinkSections(sections);
}
